// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETED_ENTRY = "Vymaz\u00e1n";
export const EXPIRED_ENTRY = "Pro\u0161l\u00fd";
export const HIDDEN_ENTRY = "nad limit";
export const INACTIVE_ENTRY = "Pozastaven\u00fd";
